import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/sessionStore';

export function AdminRoute({ children, superOnly }: { children: React.ReactNode; superOnly?: boolean }) {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/app/parcels" replace />;
  if (superOnly && user.role !== 'SUPER_ADMIN') return <Navigate to="/app/parcels" replace />;
  if (!superOnly && user.role !== 'SUPER_ADMIN' && user.role !== 'ADMINISTRATOR') {
    return <Navigate to="/app/parcels" replace />;
  }
  return <>{children}</>;
}
